/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

type FieldType = {
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  maxWidth?: number;
};

export const StyledField = styled.div<FieldType>`
  margin-top: ${({ marginTop }) => marginTop && marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom && marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft && marginLeft};
  margin-right: ${({ marginRight }) => marginRight && marginRight};
  max-width: ${({ maxWidth }) => maxWidth && `${maxWidth}px`};
  position: relative;
`;

StyledField.displayName = "StyledField";
